import React, { useLayoutEffect, useRef } from 'react'
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as am4plugins_sliceGrouper from '@amcharts/amcharts4/plugins/sliceGrouper';
import colors from '../../theme/colors'

am4core.useTheme(am4themes_animated);

const styles = {
    chartDiv: () => ({
        width: "100%",
        height: 330,
    })
}

/**
 * configure labels based on data type
 * @param series
 * @param isCountriesChart
 * @returns {*}
 */
const setLabels = (series, isCountriesChart) => {
    series.alignLabels = false;
    series.labels.template.radius = isCountriesChart ? am4core.percent(8) : am4core.percent(-30);
    // if value < 1% then position label outside of pie
    if (!isCountriesChart) {
        series.labels.template.adapter.add('radius', (radius, target) => {
            if (target.dataItem.values.value.percent < 1) {
                return am4core.percent(-1)
            }
            return am4core.percent(-30)
        })
    }
    series.ticks.template.disabled = !isCountriesChart;
    series.labels.template.events.on("ready", hideZero);
    series.labels.template.fontWeight = '600'
    series.labels.template.fontSize = isCountriesChart ? 12 : 15;
    series.labels.template.text = isCountriesChart ?
        "{category}\n({value})" :
        "{category}\n{value.percent.formatNumber('#.0')}%"
    return series
}

/**
 * colourise pie slices based on given color array or value
 * @param slices
 * @param styleColors
 * @param isSentiment
 * @returns {*}
 */
const setSliceColors = (slices, styleColors, isSentiment) => {
    return slices.map((slice, idx) => {
        const colorCode = isSentiment ? colors[slice.color] : styleColors[idx % (styleColors.length)]
        slice.category = `${slice.category[0].toUpperCase()}${slice.category.slice(1)}`
        if (colorCode)
            return {
                ...slice,
                color: am4core.color(colorCode)
            }
        return {
            ...slice
        }
    })
}

/**
 * hide slices with value < 0
 * @param ev
 */
const hideZero = (ev) => {
    if (ev.target.dataItem && (ev.target.dataItem.values.value.percent <= 0)) {
        ev.target.hide();
    }
    else {
        ev.target.show();
    }
}

/**
 * @function groupSmallSlices function to group small valued slices into 1 slice called "Other"
 * @param {Object} series
 */
const groupSmallSlices = (series) => {
    const grouper = series.plugins.push(new am4plugins_sliceGrouper.SliceGrouper());
    grouper.limit = 10 //leave the first 10 and group the rest
    grouper.groupName = "Other";
    // grouper.clickBehavior = "zoom";
}

function AmPieChart({
    data,
    seriesNames,
    amchartId,
    styleProps,
    isSentiment,
    renderedCharts
}) {
    const chart = useRef(null);

    const isCountriesChart = !isSentiment

    useLayoutEffect(() => {
        // renderedCharts.current[amchartId] = false
        // console.log("pie data", resultSet.chartPivot())
        let x = am4core.create(`chartdiv-pie-${amchartId}`, am4charts.PieChart);
        seriesNames.map(sItem => {
            let series = x.series.push(new am4charts.PieSeries());
            series.dataFields.value = sItem.key;
            series.dataFields.category = 'category';

            // if the chart data does not have an "Other" group of its own (i dont think it will but just to be safe)
            if (!data.find(item => item.category.toLowerCase() === 'other')) {
                groupSmallSlices(series)
            }

            // conf labels appearance
            series = setLabels(series, isCountriesChart)
            series.slices.template.propertyFields.fill = "color"
        })

        x.data = setSliceColors(data, styleProps.colorArray, isSentiment)
        x.logo.disabled = true

        // expand inner radius if country chart
        x.innerRadius = isCountriesChart ? am4core.percent(55) : am4core.percent(20);
        x.padding(20, 20, 20, 20)

        x.events.on("ready", () => {
            renderedCharts.current[amchartId] = true

        })

        chart.current = x;

        return () => {
            x.dispose();
        };
    }, []);

    return (
        <div id={`chartdiv-pie-${amchartId}`} style={styles.chartDiv(!isCountriesChart)} />
    );
}

export default AmPieChart;